/**
 * searchbar
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_searchbar.scss';

// Module template
import './_searchbar.twig';

// Open searchbar
$('.open-searchbar').click(() => {
  $('.header-search-block').show();
  $('.page-overlay').addClass('on');
  $('#edit-keyword').focus();
  $('.open-searchbar-button').attr('aria-expanded', 'true');
});

// Hide searchbar by clicking or pressing esc
function hideSearchbar() {
  $('.header-search-block').hide();
  $('.page-overlay').removeClass('on');
  $('.open-searchbar-button').attr('aria-expanded', 'false');
}

$('.close-searchbar, .page-overlay').click(() => {
  hideSearchbar();
});
$('.close-searchbar, .page-overlay').keydown(e => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), $('.close-searchbar, .page-overlay').click()));

$(document).keyup(e => {
  if (e.keyCode === 27) hideSearchbar(); // esc
});

export const name = 'searchbar';

export const defaults = {
  dummyClass: 'js-searchbar-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { searchbar = {} }) {
  // Find our component within the DOM
  const $searchbar = $('.searchbar', $context);
  // Bail if component does not exist
  if (!$searchbar.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = Object.assign(defaults, searchbar);
  // An example of what could be done with this component
  $searchbar.addClass(settings.dummyClass);
}

export default enable;
